// extracted by mini-css-extract-plugin
module.exports = {"root":"MenuHeading_root__10c5h","size-sm":"MenuHeading_size-sm__I6w6z","size-lg":"MenuHeading_size-lg__0Oa5r"};